const normalizeBaseUrl = url => String(url || '').replace(/\/+$/, '')

const defaultFrontendUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://www.yrm.com.br'
    : 'http://localhost:3000'

const defaultBackendUrl =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3333'
    : 'https://gestao-processo-backend-beta.onrender.com'

export const config = {
  FRONTEND_URL: process.env.NODE_ENV === 'production' ? 'https://www.yrm.com.br' : normalizeBaseUrl(process.env.REACT_APP_FRONTEND_URL || defaultFrontendUrl),
  BACKEND_URL: normalizeBaseUrl(process.env.REACT_APP_API_URL || defaultBackendUrl),
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production'
};

// Função para construir URLs completas
export const buildUrl = (path, useBackend = false) => {
  // A sessão fica presa ao endereço aberto: yrm.com.br e www.yrm.com.br não a compartilham
  const atual = typeof window !== 'undefined' ? window.location?.origin : ''
  const baseUrl = useBackend ? config.BACKEND_URL : (atual || config.FRONTEND_URL);
  return `${baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
};

export const buildApiUrl = path => buildUrl(path, true)

// Função específica para URLs do editor
export const buildEditorUrl = (documentId, params = {}) => {
  const queryParams = new URLSearchParams();
  
  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined) {
      queryParams.append(key, encodeURIComponent(params[key]));
    }
  });
  
  const queryString = queryParams.toString();
  const path = `/document-editor/${documentId}${queryString ? `?${queryString}` : ''}`;
  
  const fullUrl = buildUrl(path);


  return fullUrl;
};
